
import iframeResize from 'iframe-resizer/js/iframeResizer'


export default {
  props: {
    source: {
      type: String
    },
    title: {
      type: String
    },
    formRef: {
      type: String,
      required: true,
    },
    formId: {
      type: String,
      required: true,
    }
  },

  mounted() {
    window.addEventListener('resize', () => this.calculateIframeSize(this.formId));
  },

  methods: {
    calculateIframeSize(id) {
      try{
        iframeResize({minWidth: '100%', heightCalculationMethod: 'lowestElement', scrolling: "no"}, `#${id}`);
      }
      catch(error){
        console.log("error", error)
      }
    },
  }
}
